﻿(function ($) {
    //Decalare in Global Namespace	
    window.M2 = window.M2 || {};
    window.M2.SalesSheet = {};

    function setPrintEvent() {
        $(document).on("click", "#one-page-overlay .print", function () {
            var url = $("#TrackSalesHandoutPrint").val();
            const token = $(this).closest("form").find("input[name='__RequestVerificationToken']").val();

            $.ajax({
                url: url,
                type: 'POST',
                data: {
                    '__RequestVerificationToken': token
                },
            });
            window.print();
        });
    }

    M2.SalesSheet = {
        config: {
            name: "M2 Sales Sheet"
        },
        init: function () {
            setPrintEvent();
        }
    };
})(jQuery);

$(function () {
    M2.SalesSheet.init();
});